import { cn } from '../../lib/css/className/className';
import './useColorStatus.css';

const cls = cn('ColorStatus');

export type StatusColorProps = 'error' | 'success' | 'message' | 'warning' | 'info';

/**
 * React Hook для отображения вертикального статуса.
 */
export function useColorStatus({
    color,
    size,
}: {
    color?: StatusColorProps;
    /** Размер вертикального отступа линии статуса. По дефолту во всю высоту */
    size?: 's' | 'm' | 'l';
}): string | undefined {
    if (color) {
        return cls({ color, size });
    }

    return undefined;
}
